module.exports = __webpack_public_path__ + "img/reviewer2.5.bad4f432.png";